<div class="modal roll-api-modal">
  <div class="modal-dialog modal-dialog-scrollable user-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'developer.apiKeyManagement.rollApiKey' | translate }}</h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
          tabindex="0"
          (keydown.enter)="close()"
        ></button>
      </div>
      <div class="modal-body">
        <div class="sub-header">
          {{ 'developer.apiKeyManagement.safetyAndBestPractices' | translate }}
        </div>
        <p class="sub-text">
          {{ 'developer.apiKeyManagement.safetyAndBestPracticesSubtitle' | translate }}
        </p>
        <form [formGroup]="rollApiKeyForm" class="roll-api-form">
          <div class="input-container mb-3">
            <label for="inputKey">{{ 'developer.apiKeyManagement.key' | translate }}</label>
            <input type="text" id="inputKey" formControlName="key" readonly />
            <span class="error-text"></span>
          </div>
          <div class="input-container mb-3">
            <label for="inputNote"
              ><span class="required">*</span
              >{{ 'developer.apiKeyManagement.addANote' | translate }}</label
            >
            <input type="text" id="inputNote" formControlName="note" />
            <span class="error-text">{{ rollApiKeyFormErrors.note }}</span>
          </div>

          <div class="sub-header">
            {{ 'developer.apiKeyManagement.additionalAuthenticationRequired' | translate }}
          </div>
          <p class="sub-text">
            {{ 'developer.apiKeyManagement.additionalAuthenticationRequiredSubTitle' | translate }}
          </p>

          <div class="input-container">
            <label for="inputPassword"
              ><span class="required">*</span>
              {{ 'developer.apiKeyManagement.password' | translate }}</label
            >
            <input
              id="inputPassword"
              [type]="passwordFieldType"
              name="Password"
              class="py-2 password-input"
              formControlName="password"
              autocomplete="new-password"
            />
            <i
              class="bi"
              [ngClass]="
                passwordFieldType === 'password'
                  ? 'bi-eye-slash hide-password'
                  : 'bi-eye show-password'
              "
              (click)="onTogglePassword()"
              tabindex="0"
              (keydown.enter)="onTogglePassword()"
            ></i>
            <span class="error-text">{{ rollApiKeyFormErrors.password }}</span>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <a
          role="button"
          class="button button-clear"
          aria-label="Close"
          (click)="close()"
          tabindex="0"
          (keydown.enter)="close()"
          >{{ 'common.cancel' | translate }}</a
        >
        <a
          (click)="onSubmit()"
          tabindex="0"
          (keydown.enter)="onSubmit()"
          role="button"
          class="button button-pink"
        >
          <span>
            @if (isLoader()) {
              <span class="spinner-border spinner-border-sm"></span>
            }
            <span class="m-3">{{ 'common.confirm' | translate }}</span>
          </span></a
        >
      </div>
    </div>
  </div>
</div>
